import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import store from "../../stores/index.js";

export default class emailPlaceholderUI extends Plugin {
  init() {
    const editor = this.editor;
    editor.ui.componentFactory.add("emailPlaceholder", locale => {
      const view = new ButtonView(locale);
      view.set({
        label: "<-->",
        tooltip: false,
        withText: true
      });
      view.on("execute", () => {
        store.state.commonStore.emailPlaceholderModale = true;
        store.state.commonStore.emailPlaceholderModaleTarget = "ckeditor";
        window.ckeditor = editor;
      });
      return view;
    });
  }
}
